var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10C9.94891 10 10.1397 10.079 10.2803 10.2197C10.421 10.3603 10.5 10.5511 10.5 10.75C10.5 10.9489 10.421 11.1397 10.2803 11.2803C10.1397 11.421 9.94891 11.5 9.75 11.5H6.75C6.55109 11.5 6.36032 11.421 6.21967 11.2803C6.07902 11.1397 6 10.9489 6 10.75C6 10.5511 6.07902 10.3603 6.21967 10.2197C6.36032 10.079 6.55109 10 6.75 10H9.75ZM12.75 5C12.9489 5 13.1397 5.07902 13.2803 5.21967C13.421 5.36032 13.5 5.55109 13.5 5.75C13.5 5.94891 13.421 6.13968 13.2803 6.28033C13.1397 6.42098 12.9489 6.5 12.75 6.5H3.75C3.55109 6.5 3.36032 6.42098 3.21967 6.28033C3.07902 6.13968 3 5.94891 3 5.75C3 5.55109 3.07902 5.36032 3.21967 5.21967C3.36032 5.07902 3.55109 5 3.75 5H12.75ZM15.75 0C15.9489 0 16.1397 0.0790175 16.2803 0.21967C16.421 0.360322 16.5 0.551088 16.5 0.75C16.5 0.948912 16.421 1.13968 16.2803 1.28033C16.1397 1.42098 15.9489 1.5 15.75 1.5H0.75C0.551088 1.5 0.360322 1.42098 0.21967 1.28033C0.0790175 1.13968 0 0.948912 0 0.75C0 0.551088 0.0790175 0.360322 0.21967 0.21967C0.360322 0.0790175 0.551088 0 0.75 0H15.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.a984ec10377fc65030164d70a4531e21.svg";
export { ForwardRef as ReactComponent };